/****
 *
 *
 * Old Filter Component using redux
 * Not Using
 */

import { AxiosResponse } from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import {
  getBlocks,
  getDistricts,
  getGrades,
  getSchools,
} from "../../../../Services/Reports/ReportService";
import {
  TypeBlock,
  TypeDistrict,
  TypeGrade,
  TypeSchool,
} from "../../../../types";
import { TypeReportFilters, State } from "../../../../Reducers/types";
import {
  setBlockFilter,
  setDistrictFilter,
  setEndDateFilter,
  setGradeFilter,
  setSchoolFilter,
  setSlotFilter,
  setStartDateFilter,
} from "../../../../Reducers/Reports/reportFilterSlice";
import BlockFilter from "./BlockFilter";
import SchoolFilter from "./SchoolFilter";
import GradeFilter from "./GradeFilter";
import DistrictFilter from "./DistrictFilter";
import DateFilter from "./DateFilter";
import { reportFilters } from "../../../../Reducers";

interface IProps {
  districtFilter?: boolean;
  blockFilter?: boolean;
  schoolFilter?: boolean;
  gradeFilter?: boolean;
  weekMonth?: boolean;
  timeFilter?: boolean;
  showFilterText?: boolean;
  handleFunction?: () => void;
}

export default function Filters({
  districtFilter = true,
  blockFilter = true,
  schoolFilter = true,
  gradeFilter = false,
  timeFilter,
  weekMonth = false,
  showFilterText = true,
  handleFunction,
}: IProps) {
  const dispatch = useDispatch();
  const reportfilter: any = {};
  // const reportfilter = useSelector(
  //   (state: State) => state.reportFilter.reportFilter
  // );

  // states
  const [district, setDistrict] = useState<TypeDistrict[]>([]); // stores districts
  const [block, setBlock] = useState<TypeBlock[]>([]); // stores blocks
  const [school, setSchool] = useState<TypeSchool[]>(); // stores schools
  const [grade, setGrade] = useState<TypeGrade[]>([]); // stores grades

  const [selectedDistrict, setSelectedDistrict] = useState<TypeDistrict>(
    reportfilter?.district
  ); // stores selected district
  const [selectedBlock, setSelectedBlock] = useState<TypeBlock>(
    reportfilter?.block
  ); // stores selected block
  const [selectedSchool, setSelectedSchool] = useState<TypeSchool>(
    reportfilter?.school
  ); // stores selected school
  const [selectedGrade, setSelectedGrade] = useState<TypeGrade>(
    reportfilter?.grade
  ); // stores selected grade
  const [startDate, setStartDate] = useState<string | number>(
    reportfilter?.start_date
  ); // stores start date
  const [endDate, setEndDate] = useState<string | number>(
    reportfilter?.end_date
  ); // stores end date
  const [slot, setSlot] = useState<string>("week"); // stores slot - week or month

  // local date states
  const [date, setDate] = useState<{ start_date: string; end_date: string }>({
    start_date: "2021-11-30",
    end_date: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    fetchDiscricts();
    fetchAvailableGrades();
  }, []);

  // fetches all available grades
  const fetchAvailableGrades = () => {
    getGrades().then(
      (response: AxiosResponse) => {
        // console.log("Response for grades: ", response?.data?.data);
        setGrade(response?.data?.data);
      },
      (error) => {
        console.log("Error caught: ", error?.response);
      }
    );
  };

  // fetches discricts
  const fetchDiscricts = () => {
    // getDistricts().then(
    //   (response: AxiosResponse) => {
    //     // console.log("Response for districts: ", response?.data?.data);
    //     setDistrict(response?.data?.data);
    //     // setSelectedDistrict(response?.data?.data[0]);
    //     // dispatch(setDistrictFilter(response?.data?.data[0]));
    //   },
    //   (error) => {
    //     console.log("Error caught: ", error?.response);
    //   }
    // );
    setDistrict([{ id: 17, name: "Panchkula", state: 1 }]);
  };
  // fetches blocks
  const fetchBlocks = () => {
    // getBlocks(selectedDistrict.id).then(
    //   (response: AxiosResponse) => {
    //     // console.log("Response for blocks: ", response?.data?.data);
    //     setBlock(response?.data?.data);
    //   },
    //   (error) => {
    //     console.log("Error caught: ", error?.response);
    //   }
    // );
    setBlock([{ id: 84, district: 17, name: "Pinjore" }]);
  };
  // fetches schools
  const fetchSchools = () => {
    // getSchools(selectedBlock.id).then(
    //   (response: AxiosResponse) => {
    //     // console.log("Response for schools: ", response?.data?.data);
    //     setSchool(response?.data?.data);
    //   },
    //   (error) => {
    //     console.log("Error caught: ", error?.response);
    //   }
    // );
    setSchool([
      {
        id: 3483,
        owner: 1,
        created_on: "2022-05-04T06:21:26+00:00",
        block: 84,
        name: "3697 - Government Senior Secondary School Kalka",
        medium: 1,
        city: "01-Kalka",
        board: 2,
        school_code: "3697",
      },
      {
        id: 3487,
        owner: 1,
        created_on: "2022-05-04T06:21:27+00:00",
        block: 84,
        name: "3703 - Shaheed Major Sandeep Sagar Government Senior Secondary School Panchkula (Sector 7)",
        medium: 1,
        city: "02-Panchkula",
        board: 2,
        school_code: "3703",
      },
      {
        id: 3491,
        owner: 1,
        created_on: "2022-05-04T06:21:28+00:00",
        block: 84,
        name: "3704 - Government Senior Secondary School Panchkula (Sector 6)",
        medium: 1,
        city: "02-Panchkula",
        board: 2,
        school_code: "3704",
      },
      {
        id: 3494,
        owner: 1,
        created_on: "2022-05-04T06:21:29+00:00",
        block: 84,
        name: "3780 - Government Senior SecondarySchool Panchkula (Sector 19)",
        medium: 1,
        city: "02-Panchkula",
        board: 2,
        school_code: "3780",
      },
      {
        id: 3495,
        owner: 1,
        created_on: "2022-05-04T06:21:29+00:00",
        block: 84,
        name: "3705 - Government Girls Senior Secondary School Panchkula (Sector 15)",
        medium: 1,
        city: "02-Panchkula",
        board: 2,
        school_code: "3705",
      },
    ]);
  };

  // set date
  const handleDates = (e) => {
    e.preventDefault();
    // console.log("Start date: ", date?.start_date, "End date: ", date?.end_date);

    if (date.start_date !== "" || date.end_date !== "") {
      dispatch(setStartDateFilter(date.start_date));
      dispatch(setEndDateFilter(date.end_date));
      setStartDate(date.start_date);
      setEndDate(date.end_date);
    } else {
      dispatch(setStartDateFilter(moment().format("YYYY-MM-DD")));
      dispatch(setEndDateFilter(moment().format("YYYY-MM-DD")));
      setStartDate(moment().format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
    }
  };

  return (
    <React.Fragment>
      <div className="p-2 mt-3 filter-div-bg">
        <div>
          {!selectedDistrict?.id && showFilterText ? (
            <div className="small mb-2">
              <i className="fas fa-hand-point-down mr-1"></i>Please select the
              filters first to generate report
            </div>
          ) : (
            <></>
          )}

          {/* District */}
          <DistrictFilter
            districtFilter={selectedDistrict}
            selectedDistrict={selectedDistrict}
            showFilterText={showFilterText}
            district={district}
            changeDistrictFilters={(e) => {
              setSelectedDistrict(e);
              dispatch(setDistrictFilter(e));
            }}
          />

          {/* BLOCK */}
          <BlockFilter
            selectedDistrict={selectedDistrict}
            setBlock={setBlock}
            selectedBlock={selectedBlock}
            setSelectedBlock={setSelectedBlock}
            changeBlockFilters={(e) => {
              dispatch(setBlockFilter(e));
              setSelectedBlock(e);
            }}
            setSchool={setSchool}
            setSelectedSchool={setSelectedSchool}
            changeSchoolFilters={(e) => dispatch(setSchoolFilter(e))}
            fetchBlocks={fetchBlocks}
            blockFilter={blockFilter}
            block={block}
          />

          {/* SCHOOL */}
          <SchoolFilter
            selectedBlock={selectedBlock}
            setSchool={setSchool}
            selectedSchool={selectedSchool}
            setSelectedSchool={setSelectedSchool}
            changeSchoolFilters={(e) => {
              dispatch(setSchoolFilter(e));
              setSelectedSchool(e);
            }}
            fetchSchools={fetchSchools}
            schoolFilter={schoolFilter}
            school={school}
          />

          {/* GRADE */}
          <GradeFilter
            gradeFilter={gradeFilter}
            selectedGrade={selectedGrade}
            grade={grade}
            changeSchoolFilters={(e) => {
              dispatch(setGradeFilter(e));
              setSelectedGrade(e);
            }}
          />

          {/* DATES */}
          <DateFilter
            timeFilter={timeFilter}
            handleDates={(e) => handleDates(e)}
            date={date}
            setDate={(type, data) => {
              if (type === "start_date") {
                setStartDate(data);
                dispatch(setStartDateFilter(data));
                setDate({ ...date, start_date: data });
              } else {
                setEndDate(data);
                dispatch(setEndDateFilter(data));
                setDate({ ...date, end_date: data });
              }
            }}
            handleCancel={() => {
              setDate({ start_date: "", end_date: "" });
              setStartDate(-1);
              setEndDate(-1);
              dispatch(setStartDateFilter("2021-11-30"));
              dispatch(
                setEndDateFilter(moment().add(1, "d").format("YYYY-MM-DD"))
              );
            }}
          />

          {/* WEEK | MONTH */}
          {weekMonth && (
            <ButtonGroup>
              <Button
                color={slot === "week" ? "primary" : "secondary"}
                size="sm"
                onClick={() => {
                  setSlot("week");
                  dispatch(setSlotFilter("week"));
                }}
              >
                Week
              </Button>
              <Button
                color={slot === "month" ? "primary" : "secondary"}
                size="sm"
                onClick={() => {
                  setSlot("month");
                  dispatch(setSlotFilter("month"));
                }}
              >
                Month
              </Button>
            </ButtonGroup>
          )}

          {/* RESET BUTTON */}
          {/* selectedDistrict?.id */}
          {selectedBlock?.id || selectedGrade?.id ? (
            <Button
              size="sm"
              color="dark"
              className="ml-2"
              onClick={() => {
                // setSelectedDistrict(null);
                // dispatch(setDistrictFilter({ id: 0, name: "", district: 0 }));
                // setBlock([]);
                setSelectedBlock(null);
                dispatch(setBlockFilter(reportFilters.block));

                setSelectedSchool(null);
                dispatch(setSchoolFilter(reportFilters.school));

                setSelectedGrade(null);
                dispatch(setGradeFilter(reportFilters.grade));

                setStartDate("2021-11-30");
                dispatch(setStartDateFilter("2021-11-30"));
                setDate({ start_date: "", end_date: "" });
                setEndDate(moment().format("YYYY-MM-DD"));
                dispatch(
                  setEndDateFilter(moment().add(1, "d").format("YYYY-MM-DD"))
                );

                setSlot("week");
                dispatch(setSlotFilter("week"));
              }}
            >
              Clear <i className="fas fa-times"></i>
            </Button>
          ) : (
            <></>
          )}
        </div>

        {handleFunction ? (
          <Button size="sm" color="primary" onClick={() => handleFunction()}>
            Search
          </Button>
        ) : (
          <div></div>
        )}
      </div>
    </React.Fragment>
  );
}
